import { useState } from 'react'
import { Rating } from 'react-simple-star-rating'
import { postReview } from '../../../../API/ApiService'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router'
import { useSelector } from 'react-redux'
// import EmptyStarIcon from '../../../../assets/images/empty-star-icon.svg'
const PostReview = ({ business_id, handleRefresh }) => {
    const [rating, setRating] = useState(0)
    const [review, setReview] = useState('')
    const { loginDataSuccess } = useSelector((state) => state.LoginData);
    const navigate = useNavigate();
    const loginData = loginDataSuccess?.result;
    // Catch Rating value
    const handleRating = (rate) => {
        setRating(rate)
        // other logic
    }

    console.log();

    const handleSubmit = () => {
        if (loginData.user_state === "0") {
            navigate("/register");
            return
        }
        let body = {
            business_id,
            comment: review,
            rating,
        }
        postReview(body).then((res) => {
            console.log(res);
            if (res.status === 200) {
                toast.success('Review Posted Successfully')
                setRating(0)
                setReview('')
                handleRefresh && handleRefresh(business_id)
            }

        })
    }


    return <div style={{ margin: '50px 20px 0' }}>
        <div style={{ color: '#fff', fontSize: 24, fontWeight: 700, margin: '10px 0' }}>
            Add Review
        </div>
        <Rating
            onClick={handleRating}
            size={30}
            initialValue={rating}
            fillColor='#3ca059'
            transition
        // emptyIcon={<EmptyStarIcon size={50}/>}
        /* Available Props */
        />
        <div className="businessDetails-textarea-review-post-wrap" style={{ margin: '10px 0' }}>
            <div style={{ width: '100%', position: 'relative' }}>
                <textarea
                    className="businessDetails-textarea-review-post"
                    style={{ width: '100%', height: '112px' }}
                    placeholder="Add your review here..."
                    value={review}
                    maxLength={200}
                    onChange={(e) => setReview(e.target.value)}
                />
                <span style={{ color: '#3ca059', position: 'absolute', bottom: '10px', right: '10px', fontSize: '14px' }}>{review.length}/200</span>
            </div>
            <div onClick={handleSubmit} className="businessDetails-review-postBtn" style={{ cursor: 'pointer' }}>
                Post
            </div>
        </div>
    </div>

}

export default PostReview